import { render, staticRenderFns } from "./DoronPurchaseFormModal.vue?vue&type=template&id=1a9865b5&scoped=true&"
import script from "./DoronPurchaseFormModal.vue?vue&type=script&lang=js&"
export * from "./DoronPurchaseFormModal.vue?vue&type=script&lang=js&"
import style0 from "./DoronPurchaseFormModal.vue?vue&type=style&index=0&id=1a9865b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9865b5",
  null
  
)

export default component.exports